











































import {mixins} from "vue-class-component";
import {Component} from "vue-property-decorator";
import {CommonMixin} from "@/shared/services/mixin";
import {WardStore} from "@/modules/regionsv2/ward/store";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import WardSearch from "@/modules/regionsv2/ward/components/Search/index.vue";
import CommonStatusLabel from "@/shared/components/CommonStatusLabel/index.vue";
import {CommonStatus} from "@/enums/status";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import WardAction from "@/modules/regionsv2/ward/components/Action/index.vue";
import WardForm from "@/modules/regionsv2/ward/Form/index.vue";
import DistrictLabelV2 from "@/modules/regionsv2/DistrictLabelV2/index.vue";

const columns = [
    {
        title: '#',
        dataIndex: 'id',
        key: 'id',
        width: 20
    },
    {
        title: 'Tên phường/xã',
        dataIndex: 'name',
        key: 'name',
        scopedSlots: { customRender: 'name' },
        width: 100
    },
    {
        title: 'phường/xã',
        dataIndex: 'districtId',
        key: 'districtId',
        scopedSlots: { customRender: 'districtId' },
        width: 100
    },
    {
        title: 'Trạng thái',
        dataIndex: 'status',
        key: 'status',
        scopedSlots: { customRender: 'status' },
        width: 100
    },
    {
        title: 'Thao tác',
        dataIndex: 'id',
        key: 'action',
        scopedSlots: { customRender: 'action' },
        width: 50
    }
]
@Component({
    name: "WardList",
    components: {DistrictLabelV2, WardForm, WardAction, EnumSelector, CommonStatusLabel, WardSearch}
})
export default class extends mixins(CommonMixin) {
    columns = columns;
    CommonStatus = CommonStatus;

    get dataSource() {
        return WardStore.wards;
    }

    get pagination() {
        return {
            current: WardStore.meta.page,
            pageSize: WardStore.meta.limit,
            total: WardStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} phường/xã`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        WardStore.paramsChangeWardV21({...WardStore.params, page: pagination.current, limit: pagination.pageSize});
    }
}
